import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Gamepad2, User, LogOut, Home, Cpu, Shield } from 'lucide-react';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: Home },
    { path: '/game', label: 'Game', icon: Gamepad2 },
    { path: '/lab', label: 'Lab', icon: Cpu },
    { path: '/profile', label: 'Profile', icon: User },
    ...(user?.is_admin ? [{ path: '/admin', label: 'Admin', icon: Shield }] : []),
  ];

  return (
    <nav className="bg-black bg-opacity-20 backdrop-filter backdrop-blur-lg border-b border-white border-opacity-20">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <Gamepad2 className="h-8 w-8 text-white" />
            <span className="text-xl font-bold text-white">Airpulse Game</span>
          </Link>

          {/* Navigation Items */}
          {isAuthenticated && (
            <div className="flex items-center space-x-8">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-white bg-opacity-20 text-white'
                        : 'text-white hover:bg-white hover:bg-opacity-10'
                    }`}
                  >
                    <Icon className="h-5 w-5" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          )}

          {/* User Menu */}
          {isAuthenticated && user && (
            <div className="flex items-center space-x-4">
              <span className="text-white">Welcome, {user.username}</span>
              <button
                onClick={logout}
                className="flex items-center space-x-2 px-3 py-2 text-white hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
              >
                <LogOut className="h-5 w-5" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
